<template>
  <vx-card title="Beliebteste Zutaten">
    <div class="flex flex-wrap -mx-2">
      <div
        v-for="category in categories"
        :key="category.key"
        class="w-full lg:w-1/3 px-2 mb-4 lg:mb-0"
      >
        <h4 class="font-semibold mb-2" :style="{ color: category.color }">
          {{ category.label }}
        </h4>
        <vue-apex-charts
          type="bar"
          :height="category.items.length * 30 + 20"
          :options="getChartOptions(category)"
          :series="getSeries(category)"
        />
      </div>
    </div>
  </vx-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "AnalyticsPopularIngredients",
  components: { VueApexCharts },
  computed: {
    rawData() {
      return this.$store.state.analytics.popularIngredients || {};
    },
    categories() {
      const data = this.rawData;
      return [
        {
          key: "sauces",
          label: "Saucen",
          color: "#C41E2A",
          items: data.sauces || [],
        },
        {
          key: "meats",
          label: "Fleisch",
          color: "#2ECC71",
          items: data.meats || [],
        },
        {
          key: "salads",
          label: "Salate",
          color: "#3B82F6",
          items: data.salads || [],
        },
      ];
    },
  },
  methods: {
    getSeries(category) {
      return [
        {
          name: category.label,
          data: category.items.map((i) => i.count),
        },
      ];
    },
    getChartOptions(category) {
      return {
        chart: {
          toolbar: { show: false },
          foreColor: "#c2c6dc",
          background: "transparent",
        },
        theme: { mode: "dark" },
        grid: { show: false },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 3,
            barHeight: "60%",
          },
        },
        xaxis: {
          categories: category.items.map((i) => i._id),
          labels: { show: false },
          axisBorder: { show: false },
          axisTicks: { show: false },
        },
        yaxis: {
          labels: {
            style: { fontSize: "11px" },
            maxWidth: 120,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => val.toLocaleString("de-DE"),
          style: {
            fontSize: "10px",
            fontWeight: 500,
            colors: ["#fff"],
          },
        },
        colors: [category.color],
        fill: { opacity: 0.7 },
        tooltip: {
          y: {
            formatter: (val) => val.toLocaleString("de-DE") + "×",
          },
        },
      };
    },
  },
};
</script>
